module.exports = __webpack_public_path__ + "img/07-xl.dd54f51.webp";